module.exports = __webpack_public_path__ + "img/background-yellow.21069fea.png";